<template>
    <div class="mb-3">
        <div class="container-fluid pt-lg-1">
            <div class="d-flex justify-content-between align-items-end">
                <!--/* Zone Fil d'ariane */-->
                <ob1-breadcrumb :items="breadcrumbItems" style="min-width: 0" class="me-2 breadcrumb-full" />
                <!--/* bandeau lien et icône panier */-->
                <cart-banner
                    v-if="!searchMode"
                    :cart-link="dto.cart ? dto.cart.url : null"
                    :number-of-items="dto.cart ? dto.cart.numberOfItems : 0"
                    :cart-enabled="!!dto.cart"
                />
            </div>

            <div id="top" class="d-flex flex-wrap align-items-center mb-2" :class="searchMode ? 'justify-content-md-end' : ''">
                <h1
                    v-if="!searchMode"
                    id="header-title"
                    class="mb-0"
                    v-html="headerTitle"
                />
                <div :class="searchMode ? 'w-75' : 'ms-auto col-12 col-md-4'">
                    <equipment-search-field
                        v-if="searchFilters"
                        :place-holder="searchFilters.cartBannerSearchLabel"
                        :search-results-url="searchFilters.searchResultsUrl"
                        :search-results-query-additional-params="searchFilters.searchResultsQueryAdditionalParams"
                        :algolia-api-key="searchFilters.algoliaDto.apiKey"
                        :algolia-app-id="searchFilters.algoliaDto.appId"
                        :algolia-index-name="searchFilters.algoliaDto.indexName"
                        :enable-search-algolia="searchFilters.enableSearchAlgolia"
                        :device-list-search-url="searchFilters.deviceListSearchUrl"
                        tms-category="lr-boutique-completion"
                        tms-button-action="search"
                        tms-result-action="clic-autre-compl-"
                    />
                </div>
            </div>

            <CategoryTabs
                v-if="currentDepartment"
                class="mb-1"
                aria-label="Catégories de produits"
                :active-tab-id="currentDepartment.id"
                :tabs="departments"
                @tab-click="handleChangeDepartment($event)"
            />

            <hr class="separator separator--gray4 d-none d-xl-block">
            <div class="row">
                <!--/* Filtre partie Desktop */-->
                <section aria-label="Filtres des produits" class="col-12 col-xl-4 col-xxl-3 filters-sidebar d-none d-xl-block border-end border-gray4">
                    <bouton
                        label="Sauter les filtres et atteindre les résultats"
                        :is-primary="false"
                        class="visually-hidden-focusable"
                        @click="skipFilters()"
                    />
                    <h2 id="filters-title-desktop" class="visually-hidden">
                        Filtrer par
                    </h2>
                    <div ref="filtersDesktopTarget" />
                </section>

                <!--/*  Les deux boutons tri et filtre mode Mobile et Tablette */-->
                <div class="col-12 d-xl-none d-flex gap-md-1 w-100 mb-1 px-0 px-md-1 border-bottom-md-none border-bottom border-gray4">
                    <div
                        class="flex-fill flex-basis-0 bg-gray2 d-flex justify-content-center align-items-center padding-button border-end-md-none border-end border-gray4"
                    >
                        <h2 id="sort-title" class="visually-hidden">
                            Trier par
                        </h2>
                        <ob1-liens-icone
                            is-button
                            modal-id="sort-modal"
                            title="Trier"
                            data-bs-toggle="modal"
                            icon="icon-filter"
                            type="button"
                        />
                    </div>
                    <div
                        class="flex-fill flex-basis-0 bg-gray2 d-flex justify-content-center align-items-center padding-button"
                    >
                        <ob1-liens-icone
                            is-button
                            modal-id="filters-modal"
                            title="Filtrer"
                            class="ms-1"
                            data-bs-toggle="modal"
                            icon="icon-configuration-contrat"
                            type="button"
                        />
                    </div>
                </div>

                <div class="col-12 col-xl-8 col-xxl-9 main-content-sidebar">
                    <div class="mb-1 mt-xl-1">
                        <div class="d-flex">
                            <div
                                id="total-devices"
                                class="pe-1"
                                style="white-space: nowrap;"
                            >
                                <p class="font-size-16 lead fw-bold mb-0 me-1">
                                    <span class="aria-hidden">{{ resultsLabel }}</span>
                                    <output
                                        id="results-number-accessible"
                                        class="visually-hidden"
                                    >
                                        {{ filtersAndSortAccessibleLabel }}
                                    </output>
                                </p>
                            </div>
                            <div
                                class="chips-filters d-flex ps-1 flex-xl-wrap flex-nowrap overflow-x-auto position-relative"
                                :class="numberOfSelectedFilters > 0 ? 'border-start border-gray3 flex-fill' : 'flex-fill'"
                            >
                                <ob1-input-chips
                                    v-if="orangeOnly"
                                    id="chip-orangeOnly"
                                    additional-classes="mb-1 me-1"
                                    label="Vendu uniquement par Orange"
                                    @ob1-input-chips-click="toggleOrangeOnly(true)"
                                />
                                <ob1-input-chips
                                    v-for="selectedSelector in selectedSelectorsCheckboxes"
                                    :id="'chip-' + selectedSelector.id"
                                    :key="selectedSelector.name"
                                    additional-classes="mb-1 me-1"
                                    :label="selectedSelector.name"
                                    @ob1-input-chips-click="toggleSelector(selectedSelector.id, false, true)"
                                />
                                <ob1-input-chips
                                    v-for="selectedBrand in selectedBrandsCheckboxes"
                                    :id="'chip-' + selectedBrand.id"
                                    :key="selectedBrand.name"
                                    additional-classes="mb-1 me-1"
                                    :label="selectedBrand.name"
                                    @ob1-input-chips-click="toggleBrand(selectedBrand.id, false, true)"
                                />
                                <ob1-input-chips
                                    v-for="selectedPrice in selectedPricesCheckboxes"
                                    :id="'chip-' + selectedPrice.id"
                                    :key="selectedPrice.name"
                                    additional-classes="mb-1 me-1"
                                    :label="selectedPrice.name"
                                    @ob1-input-chips-click="togglePrice(selectedPrice.id, false, true)"
                                />
                                <ob1-input-chips
                                    v-for="selectedNote in selectedNotesCheckboxes"
                                    :id="'chip-' + selectedNote.id"
                                    :key="selectedNote.name"
                                    additional-classes="mb-1 me-1"
                                    :label="selectedNote.name"
                                    @ob1-input-chips-click="toggleNote(selectedNote.id, false, true)"
                                />
                                <ob1-input-chips
                                    v-for="statusChip in selectedStatusCheckboxes"
                                    :id="'chip-' + statusChip.id"
                                    :key="statusChip.name"
                                    additional-classes="mb-1 me-1"
                                    :label="statusChip.name"
                                    @ob1-input-chips-click="toggleStatus(statusChip.id, false, true)"
                                />
                                <ob1-liens-icone
                                    v-if="numberOfSelectedFilters > 0"
                                    is-button
                                    title="Tout effacer"
                                    class="mb-1 py-0 flex-shrink-0"
                                    icon="icon-trash"
                                    type="button"
                                    @click="onDeleteSelectionClick"
                                />
                            </div>

                            <ob1-drop-down
                                id="mobile-sortBy-desktop"
                                :is-button="true"
                                class="ms-3 d-none d-xl-block flex-shrink-0"
                                :drop-down-dto="dto.dropDownDto"
                                @ob1-drop-item-click="sortAccessories"
                            />
                        </div>
                        <!--/* Tri Mobile et Tablette*/-->
                        <div class="slide-popin-modal d-xl-none">
                            <slide-popin-modal-filter
                                id="sort-modal"
                                aria-labelledby="sort-title"
                                :button-label="'Valider la selection'"
                            >
                                <device-sort
                                    :sort-radio-buttons="sortRadioButtons"
                                    @sort-item-click="sortAccessories"
                                />
                            </slide-popin-modal-filter>
                        </div>
                        <!--/* Filtre partie Mobile et Tablette*/-->
                        <div class="slide-popin-modal d-xl-none">
                            <slide-popin-modal-filter
                                id="filters-modal"
                                aria-labelledby="filters-title"
                                :delete-selection-label="deleteSelectionLabel"
                                :number-of-selected-filters="numberOfSelectedFilters"
                                :button-label="dto.filtersButtonLabel"
                                @delete-selection-click="onDeleteSelectionClick"
                            >
                                <h2 id="filters-title" class="visually-hidden">
                                    Filtrer par
                                </h2>
                                <div ref="filtersMobileTarget" />
                            </slide-popin-modal-filter>
                        </div>
                        <!--/*  Composant Filtre unique (sera déplacé selon mobile, tablette ou desktop) */-->
                        <div ref="filtersWrapper" style="display: contents;">
                            <device-list-filters
                                v-if="!hideEmptySearchFilters"
                                :first-party-only-checked="orangeOnly"
                                :brand-checkboxes="brandCheckboxes"
                                :price-checkboxes="priceCheckboxes"
                                :note-checkboxes="noteCheckboxes"
                                :selector-groups-checkboxes="selectorGroupsCheckboxes"
                                :status-checkboxes="statusCheckboxes"
                                :department-label="currentDepartment?.label"
                                :categories="currentDepartment?.categories"
                                :selected-category="currentCategorySeoId"
                                :selected-sub-category="currentSubCategorySeoId"
                                :brand-search-label="dto.filters.brandSearchLabel"
                                :brand-search-value="brandSearchValue"
                                :collapsed-brands-label="dto.filters.collapsedBrandsLabel"
                                :not-collapsed-brands-label="dto.filters.notCollapsedBrandsLabel"
                                :results-accessible-label="filtersAndSortAccessibleLabel"
                                :third-party-enabled="dto.thirdPartyEnabled"
                                :shop-brand="dto.brand"
                                @toggle-first-party-only-filter="toggleOrangeOnly"
                                @update-brand-search-value="updateBrandSearchValue"
                                @toggle-brand-filter="toggleBrand"
                                @toggle-price-filter="togglePrice"
                                @toggle-note-filter="toggleNote"
                                @toggle-selector-filter="toggleSelector"
                                @select-category-filter="selectCategory"
                                @toggle-status-filter="toggleStatus"
                            />
                        </div>
                    </div>

                    <section aria-label="Liste des produits">
                        <div class="row">
                            <article
                                v-for="(device, index) in devices"
                                id="productsList"
                                :key="index"
                                class="col-12 col-md-6 col-xxl-4 selector-accessory-card mb-1 d-flex flex-column"
                            >
                                <device-card
                                    :device="device"
                                    :advantage-messages="dto.advantageMessages"
                                    :has-third-parties-in-cart="hasThirdPartiesInCart"
                                    :show-sold-by-infos="dto.showSoldByInfos"
                                    :funding-details="dto.fundingDetails"
                                    :enable-price-inversion="enablePriceInversion"
                                    :index="index"
                                    @fundingDetailsClick="handleFundingDetailsClick"
                                    @energyLabelClick="handleEnergyLabelClick"
                                />
                            </article>
                        </div>

                        <!--/* Message pas de résultat si recherche activée et aucun device trouvé et si on aucun filtre actif */-->
                        <div
                            v-if="searchMode && devices.length === 0 && !showAccessorySpinner && !hasActiveSearchFilters"
                            class="d-flex flex-column align-items-center text-center py-5"
                        >
                            <p class="h3">
                                Oups, on ne trouve aucun résultat pour « {{ textSearch }} »
                            </p>
                            <ul class="">
                                <li>Vérifiez l’orthographe de votre requête</li>
                                <li>Utilisez d’autres termes de recherche</li>
                            </ul>
                        </div>

                        <div v-if="showAccessorySpinner" class="d-flex justify-content-center">
                            <ob1-progress-indicators type="undetermined" :size="50" />
                        </div>
                        <div class="d-flex flex-column align-items-center py-2">
                            <bouton
                                v-if="showMoreAccessoriesButton"
                                id="showMoreButton"
                                label="Voir plus d'accessoires"
                                :is-primary="false"
                                class="mx-0 my-1"
                                :is-disabled="showAccessorySpinner"
                                @click="getMoreAccessories()"
                            />
                            <bouton
                                label="Revenir aux filtres pour affiner la recherche"
                                :is-primary="false"
                                class="visually-hidden-focusable d-xl-none"
                                data-bs-toggle="modal"
                                data-bs-target="#filters-modal"
                                aria-controls="filters-modal"
                            />
                            <bouton
                                label="Revenir aux filtres pour affiner la recherche"
                                :is-primary="false"
                                class="visually-hidden-focusable d-none d-xl-block"
                                @click="goToFilters"
                            />
                        </div>
                    </section>
                </div>
            </div>
        </div>

        <div v-if="editorialTitle && editorialDescription" class="container-fluid mt-2">
            <h2>{{ editorialTitle }}</h2>
            <p class="text-mw" v-html="editorialDescription" />
        </div>

        <div v-if="displayLegalMentions" class="bg-gray2 mt-2">
            <div class="container-fluid py-1">
                <p
                    v-if="pxfEnabled && dto.legalMentions.pxfMention && !hasThirdPartiesInCart"
                    class="fw-bold mb-0"
                    v-html="dto.legalMentions.pxfMention"
                />
                <legal-mentions4x-cb
                    v-if="cb4xEnabled && dto.legalMentions.cb4xMention && !hasThirdPartiesInCart"
                    :label="dto.legalMentions.cb4xMention"
                    :popin4x-cb="dto.legalMentions.popin4xCb"
                />
            </div>
        </div>
        <!-- Popin de financement-->
        <pxf-cb4x-modal
            v-if="selectedFundingDetailVersion"
            modal-id="funding-details-popin"
            :display-cb4x="selectedFundingDetailVersion.cb4xAvailable"
            :display-pxf="selectedFundingDetailVersion.pxfAvailable"
            :device-name="selectedFundingDetailVersion.deviceName"
        >
            <template v-if="selectedFundingDetailVersion.cb4xAvailable" #cb4x-content>
                <!-- 4xCB payant  -->
                <paying-detail-cb4x-modal-content
                    v-if="dto.fundingDetails.cb4xPopin.withFees"
                    modal-id="funding-details-popin"
                    :oney-merchant-guid="dto.fundingDetails.cb4xPopin.oneyMerchantGuid"
                    :oney-widget-src="dto.fundingDetails.oneyWidgetSrc"
                    :counter-delay="dto.fundingDetails.counterDelay"
                    :amount="selectedFundingDetailVersion.discountedPriceInCents / 100"
                    :header-block="dto.fundingDetails.cb4xPopin.headerBlock"
                    :how-to-benefit="dto.fundingDetails.cb4xPopin.howToBenefit"
                    :cgu="dto.fundingDetails.cb4xPopin.cgu"
                    :illustration="dto.fundingDetails.cb4xPopin.imageZen"
                />
                <!-- 4xCB gratuit avec détail du prix  -->
                <cb4x-modal-content
                    v-else-if="selectedFundingDetailVersion.spreadingPrice4xCbWithoutFees"
                    :header-block="dto.fundingDetails.cb4xPopin.headerBlock"
                    :payment-block="dto.fundingDetails.cb4xPopin.paymentBlock"
                    :payment-simulation-block="dto.fundingDetails.cb4xPopin.paymentSimulationBlock"
                    :how-to-benefit="dto.fundingDetails.cb4xPopin.howToBenefit"
                    :faq="dto.fundingDetails.cb4xPopin.faqBlock"
                    :cgu="dto.fundingDetails.cb4xPopin.cgu"
                    :monthly-price="selectedFundingDetailVersion.spreadingPrice4xCbWithoutFees.monthlyPrice"
                    :first-monthly-price="selectedFundingDetailVersion.spreadingPrice4xCbWithoutFees.firstMonthlyPrice"
                    :one-shot-price="selectedFundingDetailVersion.spreadingPrice4xCbWithoutFees.oneShotPrice"
                    :illustration="dto.fundingDetails.cb4xPopin.imageZen"
                />
            </template>
            <!-- Payez en 12x, 24x, 36x ou 48x  -->
            <template v-if="selectedFundingDetailVersion.pxfAvailable" #pxf-content>
                <pxf-modal-content
                    :header-block-dto="dto.fundingDetails.pxfPopin.headerBlockDto"
                    :example-pxf-data="dto.fundingDetails.pxfPopin.examplePxfData"
                    :example-pxf-tab-subtitle="dto.fundingDetails.pxfPopin.examplePxfTabSubtitle"
                    :example-pxf-tab-title="dto.fundingDetails.pxfPopin.examplePxfTabTitle"
                    :version-pxf-data="selectedFundingDetailVersion.versionPxfData"
                    :version-pxf-tab-title="dto.fundingDetails.pxfPopin.versionPxfTabTitle"
                    :pxf-legal-mentions-text="dto.fundingDetails.pxfPopin.pxfLegalMentionsText"
                    :illustration="dto.fundingDetails.pxfPopin.imageZen"
                    :financing-block="dto.fundingDetails.pxfPopin.financingBlock"
                    :cgu="dto.fundingDetails.pxfPopin.cguDto"
                    :how-to-benefit-dto="dto.fundingDetails.pxfPopin.howToBenefitDto"
                />
            </template>
        </pxf-cb4x-modal>
        <!-- Popin étiquette énergie (unique, alimentée par les tuiles) -->
        <energy-label-popin
            v-if="selectedEnergyLabel"
            :energy-label="selectedEnergyLabel"
            modal-id="energy-label-popin"
        />
    </div>
</template>

<script>
import CartBanner from "../common/CartBanner.vue";
import Cb4xModalContent from "../common/components/Cb4xModalContent.vue";
import DeviceListFilters from "./components/DeviceListFilters.vue";
import LegalMentions4xCb from "../common/components/LegalMentions4xCb.vue";
import PayingDetailCb4xModalContent from "../common/components/PayingDetailCb4xModalContent.vue";
import PxfCb4xModal from "../common/components/PxfCb4xModal.vue";
import PxfModalContent from "../common/components/PxfModalContent.vue";
import SlidePopinModalFilter from "../common/selector/fragment/SlidePopinModalFilter.vue";
import Bouton from "../../common/components/ob1/Bouton.vue";
import CategoryTabs from "../../common/components/custom/CategoryTabs.vue";
import DeviceSort from "./components/DeviceSort.vue";
import DeviceCard from "./components/DeviceCard.vue";
import {toTmsFormat} from "../../common/utils/TmsUtils";
import {scrollToElement} from "../common/Util";
import EquipmentSearchField from "../common/fragments/EquipmentSearchField.vue";
import EnergyLabelPopin from "../common/EnergyLabelPopin.vue";

const dto = JSON.parse(document.getElementById("device-list").dataset.deviceList);
const headerTitle = JSON.parse(document.getElementById("device-list").dataset.headerTitle);

const pageParam = 'page';
const sortParam = 'sort';
const orangeOnlyParam = 'orangeOnly';
const brandsParam = 'brands';
const pricesParam = 'prices';
const notesParam = 'notes';
const selectorsParam = 'selectors';
const segmentParam = 'segment';
const statusParam = 'status';

export default {
    name: "DeviceList",
    components: {
        EquipmentSearchField,
        DeviceCard,
        DeviceSort,
        CategoryTabs,
        Bouton,
        Cb4xModalContent,
        DeviceListFilters,
        LegalMentions4xCb,
        PayingDetailCb4xModalContent,
        PxfModalContent,
        PxfCb4xModal,
        SlidePopinModalFilter,
        CartBanner,
        EnergyLabelPopin
    },
    data() {
        const urlParams = new URLSearchParams(window.location.search);
        const orangeOnlyFromUrl = urlParams.get(orangeOnlyParam) === 'true';
        const pageFromUrl = urlParams.get(pageParam) ?? 1;
        const sortFromUrl = urlParams.get(sortParam);
        const brandsFromUrl = urlParams.get(brandsParam);
        const pricesFromUrl = urlParams.get(pricesParam);
        const notesFromUrl = urlParams.get(notesParam);
        const selectorsFromUrl = urlParams.get(selectorsParam);
        const statusFromUrl = urlParams.get(statusParam);

        const selectorGroupsCheckboxes = this.getSelectorGroupsCheckboxes(
            dto.filters,
            dto.segmentSeoId,
            selectorsFromUrl ? selectorsFromUrl.split(",") : []
        );
        const {editorialTitle, editorialDescription} = this.getEditorialFromSelectors(selectorGroupsCheckboxes);

        return {
            dto: dto,
            numberOfResults: dto.deviceList.numberOfResults ?? null,
            devices: dto.deviceList.devices,
            brandSearchValue: '',
            brandCheckboxes: this.getBrandCheckboxes(dto.filters, brandsFromUrl ? brandsFromUrl.split(",") : []),
            priceCheckboxes: this.getPriceCheckboxes(dto.filters, pricesFromUrl ? pricesFromUrl.split(",") : []),
            noteCheckboxes: this.getNoteCheckboxes(dto.filters, notesFromUrl ? notesFromUrl.split(",") : []),
            statusCheckboxes: this.getStatusCheckboxes(dto.filters, statusFromUrl ? statusFromUrl.split(",") : []),
            selectorGroupsCheckboxes: selectorGroupsCheckboxes,
            fundingDetailsSeoId: undefined,
            selectedEnergyLabel: undefined,
            apiRootUrl: dto.apiRootUrl,
            currentPage: Number(pageFromUrl),
            hasMoreDevices: dto.deviceList.hasMoreDevices,
            intentionParam: dto.defaultIntention,
            orangeOnly: orangeOnlyFromUrl,
            showAccessorySpinner: false,
            sort: sortFromUrl ?? "par-defaut",
            filtersAndSortAccessibleLabel: undefined,
            currentDepartmentSeoId: dto.selectedDepartmentSeoId,
            currentCategorySeoId: dto.selectedCategorySeoId,
            currentSubCategorySeoId: dto.selectedSubCategorySeoId,
            segment: dto.segmentSeoId,
            departments: this.getDepartments(dto.departments),
            isMobile: window.matchMedia("(max-width: " + (myshop.ob1.breakpoints.xl - 1) + "px)").matches,
            enablePriceInversion: dto.deviceList.priceInversionEnabled,
            pxfEnabled: dto.deviceList.pxfEnabled,
            cb4xEnabled: dto.deviceList.cb4xEnabled,
            headerTitle: headerTitle,
            searchFilters: dto.searchFilters,
            textSearch: dto.textSearch ?? null,
            editorialTitle: editorialTitle,
            editorialDescription: editorialDescription,
            fundingPopinTrigger: null
        };
    },
    computed: {
        numberOfSelectedFilters: function () {
            let totalFilters = 0;
            if (this.orangeOnly) {
                totalFilters++;
            }
            totalFilters += this.selectedBrands.length;
            totalFilters += this.selectedPrices.length;
            totalFilters += this.selectedNotes.length;
            totalFilters += this.selectedSelectors.length;
            totalFilters += this.selectedStatus.length;
            return totalFilters;
        },
        deleteSelectionLabel: function () {
            return this.dto.deleteFiltersLabel + ' (' + this.numberOfSelectedFilters + ')'
        },
        selectedFundingDetailVersion() {
            return this.devices.find(device => device.seoId === this.fundingDetailsSeoId);
        },
        showMoreAccessoriesButton() {
            return this.hasMoreDevices
        },
        shouldAlignEnergyLabel() {
            return (device) => {
                return this.showDasTooltip(device) && !this.showFundingDetailsLink(device);
            };
        },
        selectedBrandsCheckboxes() {
            return this.brandCheckboxes
                .filter(checkbox => checkbox.isChecked);
        },
        selectedPricesCheckboxes() {
            return this.priceCheckboxes
                .filter(checkbox => checkbox.isChecked);
        },
        selectedNotesCheckboxes() {
            return this.noteCheckboxes
                .filter(checkbox => checkbox.isChecked);
        },
        selectedStatusCheckboxes() {
            return this.statusCheckboxes
                .filter(checkbox => checkbox.isChecked);
        },
        selectedSelectorsCheckboxes() {
            return this.selectorGroupsCheckboxes.flatMap (group => group.selectors)
                .filter(checkbox => checkbox.isChecked);
        },
        selectedBrands() {
            return this.selectedBrandsCheckboxes.map(checkbox => checkbox.name);
        },
        encodedSelectedBrandsParam() {
            return this.selectedBrands.map(brand => encodeURIComponent(brand)).join(',');
        },
        selectedPrices() {
            return this.selectedPricesCheckboxes.map(checkbox => checkbox.value);
        },
        selectedNotes() {
            return this.selectedNotesCheckboxes.map(checkbox => checkbox.value);
        },
        selectedStatus() {
            return this.selectedStatusCheckboxes.map(checkbox => checkbox.value);
        },
        selectedSelectors() {
            return this.selectedSelectorsCheckboxes.map(checkbox => checkbox.value);
        },
        currentDepartment() {
            return this.departments.find(dept => dept.seoId === this.currentDepartmentSeoId);
        },
        currentCategory() {
            if (this.currentCategorySeoId == null) return null;
            else return this.currentDepartment.categories.find(category => category.seoId === this.currentCategorySeoId);
        },
        currentSubCategory() {
            if (this.currentSubCategorySeoId == null) return null;
            else return this.currentCategory.subCategories.find(category => category.seoId === this.currentSubCategorySeoId);
        },
        breadcrumbItems() {
            const items = [...this.dto.filAriane.items];
            if (this.currentDepartment) {
                const url = this.currentCategory ? this.currentDepartment.url : null;
                items.push({ name: this.currentDepartment.label, url: url });
            }
            if (this.currentDepartment && this.currentCategory) {
                const url = this.currentSubCategory ? this.currentCategory.url : null;
                items.push({ name: this.currentCategory.label, url: url });
            }
            if (this.currentDepartment && this.currentCategory && this.currentSubCategory) {
                items.push({ name: this.currentSubCategory.label, url: null });
            }

            if (this.searchMode) {
                items.push({ name: 'Résultats pour "' + this.textSearch + '"', url: null });
            }
            return items;
        },
        sortRadioButtons() {
            const sortOptions = [
                { id: "par-defaut", value: "", ariaLabelledBy: "pertinence", primaryText: "pertinence" },
                { id: "par-prix-asc", value: "par-prix-asc", ariaLabelledBy: "prix-croissant", primaryText: "prix croissant" },
                { id: "par-prix-desc", value: "par-prix-desc", ariaLabelledBy: "prix-decroissant", primaryText: "prix décroissant" }
            ];

            return sortOptions.map(option => ({
                radioButtonDTO: {
                    id: option.id,
                    name: "tri",
                    label: "",
                    checked: this.sort === option.id,
                    ariaLabelledBy: option.ariaLabelledBy,
                    value: option.value
                },
                primaryText: option.primaryText
            }));
        },
        hasThirdPartiesInCart() {
            return this.dto.cart?.hasThirdParties;
        },
        resultsLabel() {
            if (this.numberOfResults) return this.numberOfResults + (this.numberOfResults <= 1 ? ' résultat' : ' résultats');
            else return 'Résultats';
        },
        displayLegalMentions() {
            return (
                (this.pxfEnabled && this.dto.legalMentions.pxfMention && !this.hasThirdPartiesInCart) ||
                (this.cb4xEnabled && this.dto.legalMentions.cb4xMention && !this.hasThirdPartiesInCart)
            );
        },
        searchMode: function () {
            return !!this.textSearch;
        },
        hasActiveSearchFilters: function () {
            return this.selectedBrands.length > 0
                || this.selectedPrices.length > 0
                || this.selectedStatus.length > 0;
        },
        //On cache les filtres si on est en mode recherche, qu'aucun device n'est trouvé et qu'aucun filtre n'est actif
        hideEmptySearchFilters: function () {
            return this.searchMode
                && this.devices.length === 0
                && !this.hasActiveSearchFilters;
        },
    },
    created: function () {
    },
    mounted() {
        // Permet de déplacer le composant des filtres dans la bonne cible (mobile ou desktop)
        this.mediaQuery = window.matchMedia("(max-width: " + (myshop.ob1.breakpoints.xl - 1) + "px)");
        this.mediaQuery.addEventListener('change', this.handleBreakpointChange);
        this.moveFiltersToTarget();

        this.updateLayout();
        this.updateCurrentUrl();

        window.addEventListener("resize", () => {
            this.updateLayout();

            // Fermer les modals trir et filtre si on passe de mobile à desktop avec popin ouverte
            if (window.matchMedia("(min-width: " + myshop.ob1.breakpoints.xl + "px)").matches) {
                $('#filters-modal').modal('hide');
                $('#sort-modal').modal('hide');
            }
        });
        this.filtersAndSortAccessibleLabel = this.getFiltersAndSortLabel();

        $('#filters-modal').on('hide.bs.modal', event => {
            $('#results-number-accessible').attr("role", "status")
        });
        $('#filters-modal').on('show.bs.modal', event => {
            $('#results-number-accessible').attr("role", "off")
        });
    },
    updated() {
        this.$nextTick(function () {
            this.updateLayout();
        })
    },
    beforeDestroy() {
        if (this.mediaQuery) {
            this.mediaQuery.removeEventListener('change', this.handleBreakpointChange);
        }
    },
    methods: {
        handleFundingDetailsClick(seoId) {
            this.fundingPopinTrigger = document.activeElement;
            this.fundingDetailsSeoId = seoId;
            this.$nextTick(() => {
                this.showFundingPopin();
            });
        },
        showFundingPopin() {
            const popin = $("#funding-details-popin");
            if (popin) {
                // Restitue le focus au bouton déclencheur à la fermeture (pour l'accessibilité)
                popin.one("hidden.bs.modal", () => {
                    this.$nextTick(() => this.restoreFundingPopinFocus());
                });
                popin.modal("show");
            }
        },
        restoreFundingPopinFocus() {
            const trigger = this.fundingPopinTrigger;
            this.fundingPopinTrigger = null;
            if (trigger && trigger !== document.body && document.body.contains(trigger) && typeof trigger.focus === "function") {
                trigger.focus();
            }
        },
        handleEnergyLabelClick(seoId) {
            this.selectedEnergyLabel = this.devices.find(device => device.seoId === seoId)?.energyLabel;
            this.$nextTick(() => {
                this.showEnergyLabelPopin();
            });
        },
        showEnergyLabelPopin() {
            const popin = $("#energy-label-popin");
            if (popin) {
                popin.modal("show");
            }
        },
        toggleOrangeOnly: function (fromChips = false) {
            this.orangeOnly = !this.orangeOnly;
            const actionLabel = fromChips
                ? `choix_filtre_vendu_par_orange_supprime`
                : `choix_filtre_vendu_par_orange_coche`;
            this.tmsLink(
                fromChips ? "resultats" : "filtre_commun",
                fromChips ? "oui" : this.orangeOnly ? "oui" : "non",
                actionLabel
            );
            this.filterAccessories();
        },
        toggleBrand: function (brandId, isChecked, fromChips = false) {

            const updatedItems = [...this.brandCheckboxes];
            const itemIndex = updatedItems.findIndex(item => item.id === brandId);

            if (itemIndex !== -1) {
                updatedItems[itemIndex] = {
                    ...updatedItems[itemIndex],
                    isChecked: isChecked
                };

                this.brandCheckboxes = updatedItems;
                this.sendTmsLink(
                    updatedItems[itemIndex].name,
                    isChecked,
                    fromChips,
                    'marque'
                );
            }
            this.scrollToHeaderTitle();
            this.filterAccessories();
        },
        togglePrice: function (priceId, isChecked, fromChips = false) {

            const updatedItems = [...this.priceCheckboxes];
            const itemIndex = updatedItems.findIndex(item => item.id === priceId);

            if (itemIndex !== -1) {
                updatedItems[itemIndex] = {
                    ...updatedItems[itemIndex],
                    isChecked: isChecked
                };

                this.priceCheckboxes = updatedItems;
                this.sendTmsLink(
                    updatedItems[itemIndex].name,
                    isChecked,
                    fromChips,
                    'prix'
                );
            }
            this.scrollToHeaderTitle();
            this.filterAccessories();
        },
        toggleStatus: function (statusId, isChecked, fromChips = false) {
            const updatedItems = [...this.statusCheckboxes];
            const itemIndex = updatedItems.findIndex(item => item.id === statusId);
            if (itemIndex !== -1) {
                updatedItems[itemIndex] = {
                    ...updatedItems[itemIndex],
                    isChecked: isChecked
                };

                this.statusCheckboxes = updatedItems;
                this.sendTmsLink(
                    updatedItems[itemIndex].name,
                    isChecked,
                    fromChips,
                    'status'
                );
            }
            this.scrollToHeaderTitle();
            this.filterAccessories();
        },
        toggleNote: function (noteId, isChecked, fromChips = false) {

            const updatedItems = [...this.noteCheckboxes];
            const itemIndex = updatedItems.findIndex(item => item.id === noteId);

            if (itemIndex !== -1) {
                updatedItems[itemIndex] = {
                    ...updatedItems[itemIndex],
                    isChecked: isChecked
                };

                this.noteCheckboxes = updatedItems;
                this.sendTmsLink(
                    updatedItems[itemIndex].name,
                    isChecked,
                    fromChips,
                    'avis_client'
                );
            }
            this.scrollToHeaderTitle();
            this.filterAccessories();
        },
        toggleSelector: function (selectorId, isChecked, fromChips = false) {

            this.selectorGroupsCheckboxes = this.selectorGroupsCheckboxes.map(group => {
                const selectorIndex = group.selectors.findIndex(selector => selector.id === selectorId);
                if (selectorIndex === -1) return group;

                const updatedSelectors = [...group.selectors];
                updatedSelectors[selectorIndex] = {
                    ...updatedSelectors[selectorIndex],
                    isChecked: isChecked
                };

                return { ...group, selectors: updatedSelectors };
            });

            const group = this.selectorGroupsCheckboxes.find(group =>
                group.selectors.some(selector => selector.id === selectorId)
            );
            const selector = group?.selectors.find(selector => selector.id === selectorId);

            if (selector) {
                this.sendTmsLink(selector.name, isChecked, fromChips, 'selecteur');
            }

            const {editorialTitle, editorialDescription} = this.getEditorialFromSelectors(this.selectorGroupsCheckboxes);
            this.editorialTitle = editorialTitle;
            this.editorialDescription = editorialDescription;

            this.scrollToHeaderTitle();
            this.filterAccessories();
        },
        selectCategory: function(categoryId, subCategoryId){
            this.currentCategorySeoId = categoryId;
            this.currentSubCategorySeoId = subCategoryId;
            this.deleteAllFilters();
            this.scrollToHeaderTitle();
            this.filterAccessories();
        },
        updateBrandSearchValue: function (value) {
            this.brandSearchValue = value;
        },
        getMoreAccessories: function () {
            this.showAccessorySpinner = true;
            this.fetchAccessories(this.currentPage + 1).then(result => {
                this.currentPage = this.currentPage + 1;
                this.devices = this.devices.concat(result.devices);
                this.showAccessorySpinner = false;
                this.updateCurrentUrl();
                this.hasMoreDevices = result.hasMoreDevices;
            });
        },
        updateCurrentUrl: function () {
            let url = location.protocol + '//' + location.host + '/tech-et-accessoires';

            if (this.textSearch) {
                url += '/search/' + encodeURIComponent(this.textSearch);
            } else {
                if (this.currentDepartmentSeoId) url += '/' + this.currentDepartmentSeoId;
                if (this.currentCategorySeoId) url += '/' + this.currentCategorySeoId;
                if (this.currentSubCategorySeoId) url += '/' + this.currentSubCategorySeoId;
            }

            if (this.currentPage !== 1) url = addParam(url, pageParam + "=" + this.currentPage);
            if (this.sort && this.sort !== "par-defaut") {
                url = addParam(url, sortParam + "=" + this.sort);
            }
            if (this.orangeOnly) url = addParam(url, orangeOnlyParam + '=true')

            if (this.selectedBrands.length > 0) url = addParam(url, brandsParam + '=' + this.encodedSelectedBrandsParam);
            if (this.selectedPrices.length > 0) url = addParam(url, pricesParam + '=' + this.selectedPrices.join(','));
            if (this.selectedNotes.length > 0) url = addParam(url, notesParam + '=' + this.selectedNotes.join(','));
            if (this.selectedSelectors.length > 0) url = addParam(url, selectorsParam + '=' + this.selectedSelectors.join(','));
            if (this.selectedStatus.length > 0) url = addParam(url, statusParam + '=' + this.selectedStatus.join(','));
            if (this.segment) url = addParam(url, segmentParam + '=' + this.segment);

            // Propage les paramètres de la request d'origine non gérés par cette méthode.
            // Il est nécessaire de lister les paramètres à ne pas propager, en particulier lorsque les filtres sont supprimés
            const managedParams = [pageParam, sortParam, orangeOnlyParam, brandsParam, pricesParam, notesParam, selectorsParam, statusParam, segmentParam];
            const originalParams = new URLSearchParams(window.location.search);
            const urlObj = new URL(url);
            originalParams.forEach(function (value, key) {
                if (!managedParams.includes(key) && !urlObj.searchParams.has(key)) {
                    url = addParam(url, key + '=' + value);
                }
            });

            window.history.replaceState({}, '', url);
        },
        fetchAccessories: function (page) {
            let url = this.apiRootUrl;
            url = addParam(url, 'intention=' + this.intentionParam);
            url = addParam(url, 'brand=' + this.dto.brand);
            let pageNumber = page < 1 ? 0 : page - 1; // l'API démarre les pages à 0
            url = addParam(url, 'page=' + pageNumber);
            if (this.sort && this.sort !== 'par-defaut') {
                url = addParam(url, 'sort=' + this.sort);
            }
            if (this.orangeOnly) {
                url = addParam(url, 'firstPartyOnly=true');
            }

            if (this.selectedBrands.length > 0) {
                url = addParam(url, 'brands=' + this.encodedSelectedBrandsParam);
            }
            if (this.selectedPrices.length > 0) {
                url = addParam(url, 'prices=' + this.selectedPrices.join(','));
            }
            if (this.selectedNotes.length > 0) {
                url = addParam(url, 'notes=' + this.selectedNotes.join(','));
            }
            if (this.selectedSelectors.length > 0) {
                url = addParam(url, 'selectors=' + this.selectedSelectors.join(','));
            }
            else if (this.segment) {
                url = addParam(url, 'selectors=' + this.segment);
            }
            if (this.currentDepartmentSeoId){
                url = addParam(url, 'department=' + this.currentDepartmentSeoId)
            }
            if (this.currentCategorySeoId){
                url = addParam(url, 'category=' + this.currentCategorySeoId)
            }
            if (this.currentSubCategorySeoId){
                url = addParam(url, 'subCategory=' + this.currentSubCategorySeoId)
            }

            if (this.textSearch) {
                url = addParam(url, 'textSearch=' + encodeURIComponent(this.textSearch));
            }

            if (this.selectedStatus.length > 0) url = addParam(url, statusParam + '=' + this.selectedStatus.join(','));

            return new Promise((resolve, reject) => {
                $.ajax({
                    method: "GET",
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    url: url,
                    contentType: "application/json",
                    dataType: "json"
                }).done(result => {
                    resolve(result)
                }).fail(error => {
                    reject(error)
                    if (error.status !== 0) {
                        window.location.href = dto.infoViewUrl;
                    }
                });
            });
        },
        fetchFilters: function () {
            let url = this.apiRootUrl + "/filters";
            url = addParam(url, 'intention=' + this.intentionParam);
            url = addParam(url, 'brand=' + this.dto.brand);

            if (this.orangeOnly) {
                url = addParam(url, 'firstPartyOnly=true');
            }

            if (this.selectedBrands.length > 0) {
                url = addParam(url, 'brands=' + this.encodedSelectedBrandsParam);
            }
            if (this.selectedPrices.length > 0) {
                url = addParam(url, 'prices=' + this.selectedPrices.join(','));
            }
            if (this.selectedNotes.length > 0) {
                url = addParam(url, 'notes=' + this.selectedNotes.join(','));
            }
            if (this.selectedSelectors.length > 0) {
                url = addParam(url, 'selectors=' + this.selectedSelectors.join(','));
            }
            else if (this.segment) {
                url = addParam(url, 'selectors=' + this.segment);
            }
            if (this.currentDepartmentSeoId){
                url = addParam(url, 'department=' + this.currentDepartmentSeoId)
            }
            if (this.currentCategorySeoId){
                url = addParam(url, 'category=' + this.currentCategorySeoId)
            }
            if (this.currentSubCategorySeoId){
                url = addParam(url, 'subCategory=' + this.currentSubCategorySeoId)
            }

            if (this.textSearch) {
                url = addParam(url, 'textSearch=' + encodeURIComponent(this.textSearch));
            }

            if (this.selectedStatus.length > 0) url = addParam(url, statusParam + '=' + this.selectedStatus.join(','));

            return new Promise((resolve, reject) => {
                $.ajax({
                    method: "GET",
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    url: url,
                    contentType: "application/json",
                    dataType: "json"
                }).done(result => {
                    resolve(result)
                }).fail(error => {
                    reject(error)
                    if (error.status !== 0) {
                        window.location.href = dto.infoViewUrl;
                    }
                });
            });
        },
        sortAccessories: function (sort) {
            Tms.link({category: "selecteur_produit", action: sort.id, label: "tri"});
            this.sort = sort.id;
            this.filterAccessories();
        },
        filterAccessories: function () {
            this.devices = [];
            this.currentPage = 1;
            this.showAccessorySpinner = true;
            this.fetchFilters().then(result => {
                this.brandCheckboxes = this.getBrandCheckboxes(result, this.selectedBrands);
                this.priceCheckboxes = this.getPriceCheckboxes(result, this.selectedPrices);
                this.noteCheckboxes = this.getNoteCheckboxes(result, this.selectedNotes);
                this.statusCheckboxes = this.getStatusCheckboxes(result, this.selectedStatus);
                this.selectorGroupsCheckboxes = this.getSelectorGroupsCheckboxes(result, dto.segmentSeoId, this.selectedSelectors);
                this.updateCurrentUrl();
                this.fetchAccessories(this.currentPage).then(result => {
                    this.devices = result.devices;
                    this.numberOfResults = result.numberOfResults ?? null;
                    this.hasMoreDevices = result.hasMoreDevices;
                    this.showAccessorySpinner = false;
                    this.filtersAndSortAccessibleLabel = this.getFiltersAndSortLabel();
                    this.pxfEnabled = result.pxfEnabled;
                    this.cb4xEnabled = result.cb4xEnabled;
                });
            });
        },
        onDeleteSelectionClick: function () {
            this.deleteAllFilters();
            this.tmsLink(
                "resultats",
                "tout_effacer",
                "choix_filtre_supprime"
            );
            this.filterAccessories();
        },
        deleteAllFilters: function () {
            this.orangeOnly = false;
            this.brandCheckboxes = this.brandCheckboxes.map(checkbox => {
                return {
                    ...checkbox,
                    isChecked: false
                }
            });
            this.priceCheckboxes = this.priceCheckboxes.map(checkbox => {
                return {
                    ...checkbox,
                    isChecked: false
                }
            });
            this.noteCheckboxes = this.noteCheckboxes.map(checkbox => {
                return {
                    ...checkbox,
                    isChecked: false
                }
            });
            this.statusCheckboxes = this.statusCheckboxes.map(checkbox => {
                return {
                    ...checkbox,
                    isChecked: false
                }
            });
            this.selectorGroupsCheckboxes = this.selectorGroupsCheckboxes.map(group => ({
                ...group,
                selectors: group.selectors.map(selector => ({ ...selector, isChecked: false }))
            }));
            this.brandSearchValue = '';
            this.editorialTitle = null;
            this.editorialDescription = null;
        },
        updateLayout() {
            //nombre de tuiles par ligne selon le media (mobile, tablette et desktop)
            let nbOfTilesPerRow = 1
            if (window.matchMedia("(min-width: " + myshop.ob1.breakpoints.xxl + "px)").matches) {
                nbOfTilesPerRow = 3
            } else if (window.matchMedia("(min-width: " + myshop.ob1.breakpoints.md + "px)").matches) {
                nbOfTilesPerRow = 2
            }

            this.alignCardItemsVertically(".selector-accessory-card .mobile-infos", nbOfTilesPerRow);
            this.alignCardItemsVertically(".selector-accessory-card .infos-price", nbOfTilesPerRow);
            this.alignCardItemsVertically(".selector-accessory-card .infos-advantage", nbOfTilesPerRow);
            this.alignCardItemsVertically(".selector-accessory-card .infos-cart", nbOfTilesPerRow);
            this.alignCardItemsVertically(".selector-accessory-card .infos-seller", nbOfTilesPerRow);
            this.alignCardItemsVertically(".selector-accessory-card .payment-solutions-details", nbOfTilesPerRow);
        },
        alignCardItemsVertically(selector, nbOfTilesPerRow) {
            let listElements = document.querySelectorAll(selector);
            if (listElements.length > 0) {
                for (let row = 0; row < listElements.length; row += nbOfTilesPerRow) {
                    let tmp = [];
                    tmp.push(Array.from(listElements).slice(row, row + nbOfTilesPerRow));
                    let elements = tmp.flat()
                    if (elements.length > 0) {
                        this.alignItemsVertically(elements, nbOfTilesPerRow)
                    }
                }
            }
        },
        getMaximumHeight(list) {
            const heights = Array.from(list)
                .map(elt => $(elt).height());
            return Math.max(...heights);
        },
        alignItemsVertically(list, nbOfTilesPerRow) {
            Array.from(list).forEach(elt => {
                elt.style.removeProperty("height")
            });
            //Pas de mise à jour de hauteur de ligne pour media mobile
            if (nbOfTilesPerRow > 1) {
                const maxHeight = this.getMaximumHeight(list);
                if (maxHeight === 0) {
                    return;
                }
                Array.from(list).forEach(elt => {
                    $(elt).height(maxHeight)
                });
            }
        },
        getBrandCheckboxes(filters, selectedBrands) {
            return filters.brands.map((brand, index) => {
                let isChecked = selectedBrands.some(b => b.toLowerCase() === brand.value.toLowerCase())
                return {
                    id: 'brand-' + index,
                    name: brand.label,
                    disabled: brand.count === 0 && !isChecked,
                    label: brand.label + ' (' + brand.count + ')',
                    accessibleLabel: brand.label + ', ' + brand.count + ' produits',
                    isChecked: isChecked,
                    dataTestId: 'brand-' + index
                }
            })
        },
        getPriceCheckboxes(filters, selectedPrices) {
            return filters.prices.map((price, index) => {
                let isChecked = selectedPrices.includes(price.value);
                let label = price.count != null ? price.label + ' (' + price.count + ')' : price.label
                let accessibleLabel = price.count != null ? price.label + ', ' + price.count + ' produits' :  price.label
                return {
                    id: 'price-' + index,
                    value: price.value,
                    name: price.label,
                    disabled: price.count === 0 && !isChecked,
                    label: label,
                    accessibleLabel: accessibleLabel,
                    isChecked: isChecked,
                    dataTestId: 'price-' + index
                }
            })
        },
        getNoteCheckboxes(filters, selectedNotes) {
            return filters.notes.map((note, index) => {
                let isChecked = selectedNotes.includes(note.value);
                let label = note.count != null ? note.label + ' (' + note.count + ')' : note.label
                let accessibleLabel = note.count != null ? note.label + ', ' + note.count + ' produits' : note.label
                return {
                    id: 'note-' + index,
                    value: note.value,
                    name: note.label,
                    count: note.count,
                    disabled: note.count === 0 && !isChecked,
                    label: label,
                    accessibleLabel: accessibleLabel,
                    isChecked: isChecked,
                    dataTestId: 'note-' + index
                }
            })
        },
        getStatusCheckboxes(filters, selectedStatus) {
            return filters.status.map((status, index) => {
                let isChecked = selectedStatus.some(b => b.toLowerCase() === status.value)
                let label = status.count != null ? status.label + ' (' + status.count + ')' : status.label
                let accessibleLabel = status.count != null ? status.label + ', ' + status.count + ' produits' : status.label
                return {
                    id: 'status-' + index,
                    value: status.value,
                    name: status.label,
                    count: status.count,
                    disabled: status.count === 0 && !isChecked,
                    label: label,
                    accessibleLabel: accessibleLabel,
                    isChecked: isChecked,
                    dataTestId: 'status-' + index
                }
            })
        },
        getSelectorGroupsCheckboxes(filters, segment, selectedSelectors) {
            if (segment) return [];
            else return filters.selectorGroups.map((selectorGroup, indexGroup) => {
                return {
                    id: 'selectorGroup-' + indexGroup,
                    label: selectorGroup.label,
                    selectors : selectorGroup.selectors.map((selector, index) => {
                        let isChecked = selectedSelectors.includes(selector.value);
                        return {
                            id: 'selector-' + indexGroup + '-' + index,
                            value: selector.value,
                            name: selector.label,
                            count: selector.count,
                            disabled: false,
                            label: selector.label,
                            accessibleLabel: selector.label,
                            isChecked: isChecked,
                            dataTestId: 'selector-' + indexGroup + '-' + index,
                            editorialTitle: selector.editorialTitle,
                            editorialDescription: selector.editorialDescription
                        }
                    })
                }
            })
        },
        getFiltersAndSortLabel() {
            //Méthode volontairement non computed pour contrôler à quel moment a lieu la vocalisation
            let selectedSort = this.dto.dropDownDto.items.find(sort => sort.id === this.sort)

            let label = "";
            label += "Nous avons trouvé ";
            if (this.numberOfResults != null) label += this.resultsLabel; else label += "les résultats";
            if (this.currentDepartment != null) label += " dans la catégorie " + this.currentDepartment.label + ","
            if (this.currentCategory != null) label += " " + this.currentCategory.label + ","
            if (this.currentSubCategory != null) label += " " + this.currentSubCategory.label + ","
            if (this.numberOfSelectedFilters > 0) label += " avec les filtres "
            if (this.orangeOnly) label += " vendu uniquement par Orange,"
            if (this.selectedSelectors.length > 0) label += " sélecteur " + this.selectedSelectorsCheckboxes.map(checkBox => checkBox.name).join(', ') + ","
            if (this.selectedBrands.length > 0) label += " marque " + this.selectedBrands.join(', ') + ","
            if (this.selectedPrices.length > 0) label += " prix " + this.selectedPricesCheckboxes.map(checkBox => checkBox.name).join(', ') + ","
            if (this.selectedNotes.length > 0) label += " notes " + this.selectedNotesCheckboxes.map(checkBox => checkBox.name).join(', ') + ","
            if (this.selectedStatus.length > 0) label += " état " + this.selectedStatusCheckboxes.map(checkBox => checkBox.name).join(', ') + ","
            if (selectedSort) label += " triés " + selectedSort.label;

            return label;
        },
        getDepartments(departmentsDto) {
            return departmentsDto.map((department, index) => {
                return {
                    id: 'department-' + index,
                    label: department.label,
                    seoId: department.seoId,
                    iconName: department.icon,
                    url: department.url,
                    categories: department.categories.map ((category, catIndex) => {
                        return {
                            id: 'category-' + index + '-' + catIndex,
                            label: category.label,
                            seoId: category.seoId,
                            url: category.url,
                            subCategories : category.subCategories.map((subCategory, subCatIndex) => {
                                return {
                                    id: 'subcategory-' + index + '-' + catIndex + '-' + subCatIndex,
                                    label: subCategory.label,
                                    seoId: subCategory.seoId
                                }
                            })
                        }
                    })
                }
            })
        },

        handleChangeDepartment(departmentId) {
            const selectedDepartment = this.departments.find(dept => dept.id === departmentId);
            if (selectedDepartment) {
                this.tmsLink(
                    "header_categories",
                    toTmsFormat(selectedDepartment.label),
                    toTmsFormat(selectedDepartment.label)
                )

                this.currentDepartmentSeoId = selectedDepartment.seoId;
                this.currentCategorySeoId = null;
                this.currentSubCategorySeoId = null;
                this.currentPage = 1;
                this.deleteAllFilters();
                this.updateCurrentUrl();
                this.filterAccessories();
            }
        },
        handleBreakpointChange(e) {
            this.isMobile = e.matches;
            this.moveFiltersToTarget();
        },
        moveFiltersToTarget() {
            const filtersEl = this.$refs.filtersWrapper;
            const target = this.isMobile
                ? this.$refs.filtersMobileTarget
                : this.$refs.filtersDesktopTarget;

            if (filtersEl && target) {
                target.appendChild(filtersEl);
            }
        },
        skipFilters(){
            this.$nextTick(() => {
                const firstFocusable = this.$el.querySelector('#productsList a');
                if (firstFocusable) firstFocusable.focus();
            });
        },
        goToFilters(){
            this.$nextTick(() => {
                const firstFocusable = this.$el.querySelector('#device-list-filters a, #device-list-filters button, #device-list-filters [tabindex]:not([tabindex="-1"])');
                if (firstFocusable) firstFocusable.focus();
            });
        },
        sendTmsLink(itemName, isChecked, fromChips, type) {
            const actionLabel = fromChips
                ? `choix_filtre_${type}_supprime`
                : isChecked
                    ? `choix_filtre_${type}_coche`
                    : `choix_filtre_${type}_decoche`;

            this.tmsLink(
                fromChips ? "resultats" : "filtre_commun",
                toTmsFormat(itemName),
                actionLabel
            );
        },
        tmsLink(category, action, label) {
            Tms.link({
                category: category,
                action: action,
                label: label
            });
        },
        scrollToHeaderTitle() {
            const element = document.getElementById('top');
            if (element) {
                scrollToElement(element, {dx: 0, dy: -element.offsetHeight});
            }
        },
        getEditorialFromSelectors(selectorGroupsCheckboxes) {
            const checkedSelectors = selectorGroupsCheckboxes
                .flatMap(group => group.selectors)
                .filter(selector => selector.isChecked);
            //On prend le titre et la description du premier sélecteur coché si un seul est coché, sinon on ne prend rien
            const selector = checkedSelectors.length === 1 ? checkedSelectors[0] : null;
            return {
                editorialTitle: selector?.editorialTitle ?? null,
                editorialDescription: selector?.editorialDescription ?? null
            };
        }
    }
};
</script>

<style scoped lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

.energy-label-padding {
    padding: .4375rem 0 .625rem;
}

@media (max-width: #{map-get($grid-breakpoints, xl)}) {
    .chips-filters {
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE/Edge */
        .ob1-inputchip {
            flex-shrink: 0; // Empêche la compression des chips
        }
    }
}

@media (max-width: #{map-get($grid-breakpoints, xl)}) {
    .padding-button{
        padding: 5px 0 2px 0;
    }
}

.flex-basis-0 {
    flex-basis: 0 !important;
}

@media (min-width: #{map-get($grid-breakpoints, xxl)}) {
    .filters-sidebar {
        flex: 0 0 22%;
        max-width: 22%;
    }

    .main-content-sidebar {
        flex: 0 0 78%;
        max-width: 78%;
    }
}

@media (min-width: #{map-get($grid-breakpoints, xl)}) and (max-width: #{map-get($grid-breakpoints, xxl) - 1}) {
    .filters-sidebar {
        flex: 0 0 27%;
        max-width: 27%;
    }

    .main-content-sidebar {
        flex: 0 0 73%;
        max-width: 73%;
    }
}

@media (min-width: #{map-get($grid-breakpoints, md)}) {
    .border-bottom-md-none {
        border-bottom: none !important;
    }
    .border-end-md-none {
        border-right: none !important;
    }
}

.breadcrumb-full ::v-deep .breadcrumb {
    max-width: 100%;
}

</style>
